export const DISPLAY_DATE_WITH_TIME = "M/d/yyyy h:mm:ssa";
export const DISPLAY_HOUR_MINUTE = "h:mm a";
export const DISPLAY_DATE = "M/d/yyyy";
export const MONTH_DAY_YEAR_INPUT_DATE_FORMAT = "MM/dd/yyyy";
export const MONTH_DAY_YEAR_HOUR_MINUTE_DATE_FORMAT = "MM/dd/yyy h:mm a";
export const MONTH_YEAR_INPUT_DATE_FORMAT = "MM/yyyy";
export const SERVER_TIME_FORMAT = "HHmmss";
export const SERVER_DATE_TIME_FORMAT = "yyyyMMddHHmmss";
export const SERVER_DATE_FORMAT = "yyyyMMdd";
export const SERVER_DATE_HOUR_FORMAT = "yyyyMMddHH";